__webpack_require__.p = "https://v2-styler.apps.qorcommerce.io/";